import { Component, inject } from '@angular/core';
import { ModalService } from 'src/utils/modal.service';
import { ToastService } from 'src/utils/toast.service';
import { ButtonsComponent } from './buttons/buttons.component';
import { DropdownSimpleComponent } from './dropdowns/simple/dropdown-simple.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CountryService } from 'src/utils/country.service';
import { SelectorPhoneCountry } from '../interfaces/selector-country.interfaces';
import { HttpClientModule } from '@angular/common/http';
import { TabComponent } from './tab/tab.component';
import { TabsComponent } from './tabs/tabs.component';
import { TableComponent } from './tables/table/table.component';
import { MOCK_COLUMNS, TABLE_MOCK_DATA } from './tables/table/table.mock';
import { SelectorComponent } from './selectors/simple/selector.component';
import { BaseModalService } from 'src/utils/base-modal.service';
import { BaseModalExampleComponent } from './base-modal/base-modal-example/base-modal-example.component';
import { SearchableDropdownComponent } from './searchable-dropdown/searchable-dropdown.component';
import { MultiselectComponent } from './multiselect/multiselect.component';
import { OptionsModalService } from 'src/utils/options-modal.service';
import { SimpleTableComponent } from './tables/simple-table/simple-table.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { InputDateComponent } from './input-date/input-date.component';
import { FormPreviewerComponent } from './form-previewer/form-previewer.component';
import { PrecreditToogleComponent } from './precredit-toogle/precredit-toogle.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ButtonsComponent,
    DropdownSimpleComponent,
    CheckboxComponent,
    HttpClientModule,
    TabComponent,
    TabsComponent,
    TableComponent,
    SelectorComponent,
    SearchableDropdownComponent,
    MultiselectComponent,
    SimpleTableComponent,
    UploadFileComponent,
    InputDateComponent,
    FormPreviewerComponent
  ],
  templateUrl: './component-test.component.html',
})
export class ComponentTest {
  public modalService = inject(ModalService);
  public toastService = inject(ToastService);
  public modalBaseService = inject(BaseModalService);
  public optionsModalService = inject(OptionsModalService);
  countries: SelectorPhoneCountry[] = [];
  columns = MOCK_COLUMNS;
  users = TABLE_MOCK_DATA;

  testForm: FormGroup;

  constructor(private fb: FormBuilder, private countryService: CountryService) {
    this.testForm = this.fb.group({
      phone: ['', Validators.required],
      fechaNacimiento: ['', Validators.required],
    });
  }
  filterOptions = {
    estado: [
      { label: 'Activo', value: 'activo' },
      { label: 'Inactivo', value: 'inactivo' },
    ],
    tipoCarga: [
      { label: 'Manual', value: 'manual' },
      { label: 'Automática', value: 'automatica' },
    ],
  };

  multiselectOptions = [
    { value: 'productoA', label: 'Producto A', active: false },
    { value: 'productoB', label: 'Producto B', active: false },
    { value: 'productoC', label: 'Producto C', active: false },
    { value: 'productoD', label: 'Producto D', active: false },
    { value: 'productoE', label: 'Producto E', active: false },
    { value: 'productoF', label: 'Producto F', active: false },
    { value: 'productoG', label: 'Producto G', active: false },
    { value: 'productoH', label: 'Producto H', active: false },
    { value: 'productoI', label: 'Producto I', active: false },
    { value: 'productoJ', label: 'Producto J', active: false },
    { value: 'productoK', label: 'Producto K', active: false },
  ];

  searchableOptions = [
    { value: 'productoA', label: 'Producto A' },
    { value: 'productoB', label: 'Producto B' },
    { value: 'productoC', label: 'Producto C' },
    { value: 'productoD', label: 'Producto D' },
    { value: 'productoE', label: 'Producto E' },
    { value: 'productoF', label: 'Producto F' },
    { value: 'productoG', label: 'Producto G' },
    { value: 'productoH', label: 'Producto H' },
    { value: 'productoI', label: 'Producto I' },
    { value: 'productoJ', label: 'Producto J' },
    { value: 'productoK', label: 'Producto K' },
  ];

  filterLabels = {
    estado: 'Estado',
    tipoCarga: 'Tipo de carga',
  };

  uploadFileValidFormats = ['png', 'jpeg'];

  ngOnInit() {
    this.countryService.getCountries().subscribe((countries) => {
      this.countries = countries;
    });
  }

  onSubmit() {
  }

  showToast(): void {
    this.toastService.showToast(
      'fi fi-ss-check-circle text-[24px] text-[#17BF33]',
      'hubo un problema al colocar tu contraseña intenta de nuevo por favor',
      'success'
    );
  }

  showModal(): void {
    this.optionsModalService.show({
      title: 'Selecciona el origen de la lista',
      modalLayout: 'options-horizontal',
      showFooter: false,
      options: [
        { icon: 'fi fi-rr-file-csv', title: 'Archivo CSV', value: 'csv' },
        { icon: 'fi fi-rr-file-code', title: 'Archivo XML', value: 'xml' },
        { icon: 'fi fi-rr-api', title: 'Conectar vía API', value: 'api' },
      ],
      continueButtonText: 'Continuar',
      showModalDisclaimer: false,
      cancelButtonText: 'Cancelar',
      btnCancelar: true,
      onConfirm: () => {},
    });
  }
  showModal2(): void {
    this.optionsModalService.show({
      title: 'Seleccionar tipo de lista',
      modalLayout: 'select-vertical',
      subtitle: 'Elige el plan que mejor se adapte a tus necesidades',
      options: [
        {
          icon: 'fi-rr-shield',
          title: 'Básico',
          description: 'Plan básico',
          value: 'basic',
        },
        {
          icon: 'fi-rr-layers',
          title: 'Premium',
          description: 'Plan premium',
          value: 'premium',
        },
      ],
      cancelButtonText: 'Cancelar',
      cancelButtonType: 'dark-borderless',
      continueButtonText: 'Continuar',
      continueButtonType: 'secundary-inverted',
      btnCancelar: true,
      onConfirm: () => {},
    });
  }
  showModal3(): void {
    this.optionsModalService.show({
      title: 'Gestionar categorías de homologación',
      modalLayout: 'categories',
      options: [
        {
          title: 'Información comercial',
          items: ['Nombre comercial', 'Sector económico', 'Años en el mercado'],
        },
        { title: 'Interna del cliente', items: ['Campo A', 'Campo B'] },
        { title: 'Lorem ipsum dolor', items: ['Otro campo'] },
      ],
      continueButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      showModalDisclaimer: false,
      btnCancelar: true,
      showFooter: true,
      onConfirm: () => {},
    });
  }
  async showModal4() {
    const result = await this.modalBaseService.open(BaseModalExampleComponent, {
      title: 'Modal de prueba',
      showFooter: true,
      showHeader: true,
      inputs: { name: 'Juan' },
    });

  }

  async showModalTest() {
  this.modalService.showModal({
            modalType: 'info',
            iconClass: 'fi fi-sr-exclamation text-warning-100 text-2xl-plus ',
            title: 'Proceda con precaución',
            message:
              `Esta función está en uso wwwwwwwwwwwwwwwwwwwwwwwwwwwwww, los cambios podrían afectar otros productos o reglas configuradas.`,
            btnCancelar: true,
            continueButtonText: 'Confirmar',
            customMessageClasses:
              'font-poppins font-medium text-[14px] text-text-primary text-center leading-5 mt-[3px] mb-3',
            customModalClasses:
              'bg-light rounded-3xl shadow-modal pb-6 xs:pb-8 pt-[40px] xs:pt-[40px] px-4 xs:px-6 w-[440px] max-w-full h-auto',
            onConfirm: () => {}
          });
  }

  async showFormPreviewerModal() {
    let modalComponent: any;
    
    const result = await this.modalBaseService.open(FormPreviewerComponent, {
      title: 'Vista previa',
      showFooter: false,
      showHeader: true,
      width: '80%',
      inputs: {
        onModalWidthChange: (width: string) => {
          // Obtener la referencia al modal y actualizar su ancho
          const modal = (this.modalBaseService as any).modals.find((m: any) => m.visible);
          if (modal) {
            modal.width = width;
            modal.cdr.detectChanges();
          }
        }
      },
    });

  }

  onPhoneChange(value: string) {
  }

  onSearch(text: string) {
  }

  onPageChange({ page, limit }: { page: number; limit: number }) {
  }

  onSort(event: { column: string; direction: 'asc' | 'desc' }) {
  }

  onTableAction(event: { row: any; action: string }) {
  }

  onEdit(row: any) {
  }

  onDelete(row: any) {
  }

  onToggle(event: { row: any; checked: boolean }) {
  }

  handleSelectionChange(value: any) {
  }

  onSelect(value: any) {
  }

  onFileSelected(file: File) {
  }
}
